/**
 * Supported GCP regions for the dashboard's connect + scope UI. Mirrors
 * services/shared/gcp-regions.ts (kept in sync manually — the dashboard cannot
 * import from the backend workspace).
 */

export interface GcpRegionOption {
  code:  string;
  label: string;
}

export const SUPPORTED_GCP_REGIONS: GcpRegionOption[] = [
  { code: 'us-central1',            label: 'Iowa' },
  { code: 'us-east1',               label: 'South Carolina' },
  { code: 'us-east4',               label: 'N. Virginia' },
  { code: 'us-west1',               label: 'Oregon' },
  { code: 'us-west2',               label: 'Los Angeles' },
  { code: 'europe-west1',           label: 'Belgium' },
  { code: 'europe-west2',           label: 'London' },
  { code: 'europe-west3',           label: 'Frankfurt' },
  { code: 'europe-north1',          label: 'Finland' },
  { code: 'asia-south1',            label: 'Mumbai' },
  { code: 'asia-southeast1',        label: 'Singapore' },
  { code: 'asia-east1',             label: 'Taiwan' },
  { code: 'asia-northeast1',        label: 'Tokyo' },
  { code: 'australia-southeast1',   label: 'Sydney' },
  { code: 'southamerica-east1',     label: 'São Paulo' },
  { code: 'northamerica-northeast1', label: 'Montréal' },
];

export function regionLabel(code: string): string {
  return SUPPORTED_GCP_REGIONS.find(r => r.code === code)?.label ?? code;
}
